import { render } from "./MobileFeatured.vue?vue&type=template&id=5b26397d&scoped=true"
import script from "./MobileFeatured.vue?vue&type=script&lang=js"
export * from "./MobileFeatured.vue?vue&type=script&lang=js"

import "./MobileFeatured.vue?vue&type=style&index=0&id=5b26397d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b26397d"]])

export default __exports__